/**
 * @generated SignedSource<<769be35d8f633045ce8d82b4effcc486>>
 * @relayHash 35c031f0e551ffdb1606790bd7317186
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2832ec15692c6414d21b36725e02826a8bac361ed767cd6564b8dccad7572b87

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PopupContentNav3Query } from './PopupContentNav3Query.graphql';

const node: PreloadableConcreteRequest<PopupContentNav3Query> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2832ec15692c6414d21b36725e02826a8bac361ed767cd6564b8dccad7572b87",
    "metadata": {},
    "name": "PopupContentNav3Query",
    "operationKind": "query",
    "text": null
  }
};

export default node;
